import { Flex, Spin } from 'antd'
import { t } from 'i18next'
import React, { useContext, useState } from 'react'
import { post } from '../../Common/api'
import OwnerFilter from './OwnerFilter'
import OwnerList from './OwnerList'
import OwnerForm from './OwnerForm'
import { useForm } from 'antd/es/form/Form'
import { PlusOutlined } from '@ant-design/icons'
import CustModal from '../../Common/CustModal'
import GlobalContext from '../GlobalContext'
import { ActionButton } from '../../Common/Common'

export default function OwnersPage () {
  const { owners } = useContext(GlobalContext)
  const [filter, setFilter] = useState({ name: '' })
  const [loading, setLoading] = useState(false)
  const [modalVisible, setModalVisible] = useState(false)
  const [form] = useForm()
  const { notificationApi } = useContext(GlobalContext)

  const postOwner = async (params) => {
    setLoading(true)
    await post({
      url: 'admin/owners',
      params,
      notification: { api: notificationApi, state: 'create' },
      onSuccess: () => {
        setModalVisible(false)
        setLoading(false)
      },
      onFailure: (errors) => {
        setLoading(false)
        form.setFields(
          Object.keys(errors).map((key) => ({
            name: key,
            errors: errors[key]
          }))
        )
      }
    })
  }

  const onChangeFilter = (filter) => {
    setFilter(filter)
  }

  const filteredOwners = (owners || []).filter((owner) => {
    return owner.name.toLowerCase().includes(filter.name.toLowerCase())
  })

  const openAddModal = () => {
    form.resetFields()
    setModalVisible(true)
  }

  const onAdd = async (values) => {
    await postOwner(values)
  }

  return (
    <Flex vertical>
      <Flex align='center' style={{ margin: '1em 0' }}>
        <div style={{ marginRight: '20px', fontSize: '20px' }}><b>{(owners || []).length}</b> {t('Admin.OwnersPage.title')}</div>
        <OwnerFilter filter={filter} onChangeFilter={onChangeFilter} />
        <ActionButton onClick={openAddModal} type="primary" style={{ marginLeft: 'auto' }} shape="circle" icon={<PlusOutlined />} />
      </Flex>
      <Spin spinning={loading}>
        { owners && <OwnerList owners={filteredOwners} /> }
        <CustModal
          open={modalVisible}
          setOpen={setModalVisible}
          width="1000px"
          title={t('Admin.OwnersPage.addOwnerTitle')}
          onOk={form.submit}
          confirmLoading={loading}
        >
          <Spin spinning={loading}>
            <OwnerForm form={form} onFinish={onAdd} />
          </Spin>
        </CustModal>
      </Spin>
    </Flex>
  )
}
